class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    if (document.querySelector('.facets-type-drawer')) FacetFiltersForm.loadPriceRangeMobile();
    if (document.querySelector('.facets-type-vertical')) FacetFiltersForm.loadPriceRangeSidebar();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    if (!document.getElementById('ProductCount')) return;
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
    if (document.querySelector('.facets-type-drawer')) FacetFiltersForm.loadPriceRangeMobile();
    if (document.querySelector('.facets-type-vertical')) FacetFiltersForm.loadPriceRangeSidebar();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  static loadPriceRangeSidebar() {
    const inputValueMin = document.querySelector("#FacetFiltersForm .input__price-min");
    const inputValueMax = document.querySelector("#FacetFiltersForm .input__price-max");
    const slideValueMin = document.querySelector("#FacetFiltersForm .range__price-min");
    const slideValueMax = document.querySelector("#FacetFiltersForm .range__price-max");
    const thumbLeft = document.querySelector("#FacetFiltersForm .slider > .thumb.left");
    const thumbRight = document.querySelector("#FacetFiltersForm .slider > .thumb.right");
    const range = document.querySelector("#FacetFiltersForm .slider > .range");

    FacetFiltersForm.updatePriceRangeFilter(inputValueMin, inputValueMax, slideValueMin, slideValueMax, thumbLeft, thumbRight, range);
  }

  static loadPriceRangeMobile() {
    const inputValueMin = document.querySelector("#FacetFiltersFormMobile .input__price-min");
    const inputValueMax = document.querySelector("#FacetFiltersFormMobile .input__price-max");
    const slideValueMin = document.querySelector("#FacetFiltersFormMobile .range__price-min");
    const slideValueMax = document.querySelector("#FacetFiltersFormMobile .range__price-max");
    const thumbLeft = document.querySelector("#FacetFiltersFormMobile .slider > .thumb.left");
    const thumbRight = document.querySelector("#FacetFiltersFormMobile .slider > .thumb.right");
    const range = document.querySelector("#FacetFiltersFormMobile .slider > .range");

    FacetFiltersForm.updatePriceRangeFilter(inputValueMin, inputValueMax, slideValueMin, slideValueMax, thumbLeft, thumbRight, range);
  }

  static updatePriceRangeFilter(inputValueMin, inputValueMax, slideValueMin, slideValueMax, thumbLeft, thumbRight, range) {
    FacetFiltersForm.setLeftValuePriceRange(slideValueMin, slideValueMax, inputValueMin, thumbLeft, range, false);
    FacetFiltersForm.setRightValuePriceRange(slideValueMax, slideValueMin, inputValueMax, thumbRight, range, false);

    const context = this;
    
    slideValueMin.addEventListener("input", (e) => {
      e.preventDefault();
      context.setLeftValuePriceRange(slideValueMin, slideValueMax, inputValueMin, thumbLeft, range, true);
    });
    slideValueMax.addEventListener("input", (e) => {
      e.preventDefault();
      context.setRightValuePriceRange(slideValueMax, slideValueMin, inputValueMax, thumbRight, range, true);
    });

    inputValueMin.addEventListener("input", function (e) {
      slideValueMin.value = e.target.value || 0;
      context.setLeftValuePriceRange(slideValueMin, slideValueMax, inputValueMin, thumbLeft, range, true);
    });

    inputValueMax.addEventListener("input", function (e) {
      slideValueMax.value = e.target.value || 0;
      context.setRightValuePriceRange(slideValueMax, slideValueMin, inputValueMax, thumbRight, range, true);
    });

    slideValueMin.addEventListener("mouseover", function() {
      thumbLeft.classList.add("hover");
    });
    slideValueMin.addEventListener("mouseout", function() {
      thumbLeft.classList.remove("hover");
    });
    slideValueMin.addEventListener("mousedown", function() {
      thumbLeft.classList.add("active");
    });
    slideValueMin.addEventListener("mouseup", function() {
      thumbLeft.classList.remove("active");
    });

    slideValueMax.addEventListener("mouseover", function() {
      thumbRight.classList.add("hover");
    });
    slideValueMax.addEventListener("mouseout", function() {
      thumbRight.classList.remove("hover");
    });
    slideValueMax.addEventListener("mousedown", function() {
      thumbRight.classList.add("active");
    });
    slideValueMax.addEventListener("mouseup", function() {
      thumbRight.classList.remove("active");
    });
  }

  static setLeftValuePriceRange(slideValueMin, slideValueMax, inputValueMin, thumbLeft, range, inputChanged) {
    const _this = slideValueMin;
    const min = parseInt(_this.min);
    const max = parseInt(_this.max);
    const value = Math.min(parseInt(_this.value || 0), parseInt(slideValueMax.value) - 1);

    _this.value = value;
    if (inputChanged) {
      inputValueMin.value = value;
    }

    const percent = ((_this.value - min) / (max - min)) * 100;

    thumbLeft.style.left = percent + "%";
    range.style.left = percent + "%";
  }

  static setRightValuePriceRange(slideValueMax, slideValueMin, inputValueMax, thumbRight, range, inputChanged) {
    const _this = slideValueMax;
    const min = parseInt(_this.min);
    const max = parseInt(_this.max);

    _this.value = Math.max(parseInt(_this.value), parseInt(slideValueMin.value || 0) + 1);
    if (inputChanged) {
      inputValueMax.value = Math.max(parseInt(_this.value), parseInt(slideValueMin.value || 0) + 1);
    }

    const percent = ((_this.value - min) / (max - min)) * 100;

    thumbRight.style.right = (100 - percent) + "%";
    range.style.right = (100 - percent) + "%";
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
